import _ from 'lodash';
import React, { useEffect } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Route, Switch } from 'react-router';

import AdviserHome from '../components/pages/AdviserHome';
import ClientDataExchangeHome from '../components/pages/ClientDataExchangeHome';
import {
	NavigationTree,
	NavTreeItem,
} from '../logic/domains/navigationTree.domain';

import SecureLayout from '../components/layouts/SecureLayout';
import PlanProfile from '../components/pages/PlanProfile';
import SearchResultsPage from '../components/pages/SearchResultsPage';
import withScripting from '../components/hoc/Scripting';
import PageLayout from '../components/layouts/PageLayout';
import NotFound from '../components/presentational/Error/NotFound';
import { flattenNavTreeToRoutes } from './util/NavTreeRouteMapper.util';
import RoutingElements from './Routing.elements';
import getAllBannerItems from './util/HeaderBannerRouteMapper';
import { history } from '..';

interface Props {
	navigationTree: NavigationTree;
}

const Routing: React.FunctionComponent<Props> = (props: Props) => {
	const breadCrumbs = getAllBannerItems(props.navigationTree, configuredRoutes);

	return (
		<ConnectedRouter history={history}>
			<SecureLayout navigationTree={props.navigationTree}>
				<Switch>
					<Route
						path="/timeout"
						render={() => {
							window.location.href = '/logout?logoutReason=timeout';
							return null;
						}}
					/>
					{_.map(
						/*
								Cloning allows for the subpages array to be removed without affecting the HeaderBanner, not really
								necessary but makes the returned array a little cleaner without duplicates between levels
							*/
						flattenNavTreeToRoutes(
							props.navigationTree,
							_.cloneDeep(configuredRoutes)
						),
						route => {
							return (
								<Route key={route.key} path={route.path} exact={true}>
									<PageLayout
										headerTitle={route.headerTitle}
										Component={route.component}
										showQuickLinks={
											route.showQuickLinks === undefined
												? true
												: route.showQuickLinks
										}
										showBanner={
											route.showBanner === undefined ? true : route.showBanner
										}
										bannerItem={breadCrumbs.find(b => b.key === route.key)}
									/>
								</Route>
							);
						}
					)}
					<Route path="*" exact={true} component={NotFound} />
				</Switch>
			</SecureLayout>
		</ConnectedRouter>
	);
};

export const configuredRoutes: NavTreeItem[] = [
	{
		key: 'home',
		path: '/',
		showBanner: false,
		showQuickLinks: true,
		title: 'Home',
		headerTitle: 'Dashboard',
		component: AdviserHome,
	},
	{
		key: 'client-data-exchange', // key matched from the AEM NavMenu response
		path: '/myBusiness/clientDataExchange',
		showBanner: true,
		showQuickLinks: true,
		component: ClientDataExchangeHome,
		title: 'Client Data Exchange',
		headerTitle: 'Client data exchange',
	},
	{
		key: 'plan-profile',
		path: '/planProfile/:planUUID',
		title: 'Plan Profile',
		headerTitle: 'Adviser Plan Profile',
		showBanner: true,
		showQuickLinks: false,
		component: PlanProfile,
	},
	{
		key: 'search',
		path: '/search',
		title: 'Client search results',
		headerTitle: 'Client Search Results',
		showBanner: true,
		showQuickLinks: true,
		component: SearchResultsPage,
		titleTestId: RoutingElements.searchHeaderId,
	},
];

export default withScripting(Routing);
